// ----------------------------------------------------------------------------- //
// Toggle the site header when user scroll up or down
// ----------------------------------------------------------------------------- //
const masthead = document.getElementById("masthead");

if ( masthead ) {

	let lastScroll = 0;

	window.addEventListener("scroll", () => {

		let scrollPosition = window.scrollY;
		let currentScroll = window.scrollY;

		lastScroll = currentScroll;
	});
}
